import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { DriversState } from '../../types';

import { getDriverFuelAssignmentsCards } from '../operations/getDriverFuelAssignmentsCards';

import { STATUS_LOADING } from 'common/constants';

export const setDriverFuelAssignmentsCards = (builder: ActionReducerMapBuilder<DriversState>) => builder
  .addCase(getDriverFuelAssignmentsCards.pending, (state) => {
    state.fuelAssignmentsCards.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getDriverFuelAssignmentsCards.fulfilled, (state, { payload }) => {
    state.fuelAssignmentsCards.loadingStatus = STATUS_LOADING.done;
    state.fuelAssignmentsCards.data = payload;
  })
  .addCase(getDriverFuelAssignmentsCards.rejected, (state) => {
    state.fuelAssignmentsCards.loadingStatus = STATUS_LOADING.error;
  });